import { createApi } from "@reduxjs/toolkit/query/react";
import endpoints, { baseURL } from "data/api/v1/endpoints.ts";

import { baseQueryWithRedirect } from "features/api/utils/apiUtils.ts";
import { models } from "types/api/viewModels.ts";

interface UploadImageDataModel {
	blobUri: string;
	credentials: string;
	sasUri: string;
}

export const imageApiSlice = createApi({
	reducerPath: "imageApi",
	baseQuery: baseQueryWithRedirect(baseURL),
	endpoints: (builder) => ({
		getImageUploadDataByOrderId: builder.query<UploadImageDataModel, string>({
			query: (tandemOrderId: string) => endpoints.images.getUploadDataById(tandemOrderId),
			transformResponse: (response: { data: UploadImageDataModel }) => response?.data,
			transformErrorResponse: (error: { status: string | number }) => ({
				status: error?.status
			})
		}),
		getImageDownloadDataByOrderId: builder.query<models["SasToken"], string>({
			query: (tandemOrderId: string) => endpoints.images.getDownloadDataById(tandemOrderId),
			transformResponse: (response: { data: models["SasToken"] }) => response?.data,
			transformErrorResponse: (error: { status: string | number }) => ({
				status: error?.status
			})
		}),
		deleteImageDownloadDataByOrderId: builder.query<models["SasToken"], string>({
			query: (tandemOrderId: string) => endpoints.images.deleteDownloadDataById(tandemOrderId),
			transformResponse: (response: { data: models["SasToken"] }) => response?.data,
			transformErrorResponse: (error: { status: string | number }) => ({
				status: error?.status
			})
		})
	})
});

export const {
	useLazyGetImageUploadDataByOrderIdQuery,
	useLazyGetImageDownloadDataByOrderIdQuery,
	useLazyDeleteImageDownloadDataByOrderIdQuery
} = imageApiSlice;
